export default "__VITE_ASSET__B_I3yi3b__"